<template>
    <div class="model-search-container">
        <form
            class="search-form"
            @submit.prevent="performModelSearch"
        >
            <div @click="performModelSearch" class="search-icon-box">
              <!-- <span
                  class="search-icon"
              ></span> -->
              <i class="fas fa-solid search-icon"></i>
            </div>
            <input
                type="text"
                ref="searchInput"
                v-model="textToSearch"
            />
        </form>
    </div>
</template>
<script>
import FontAwesome from "../../../public/js/lib/FontAwesomeKit"; // <--- importing FontAwesome icons

export default {
  name: "SearcherModelInput",
  data() {
    return {
      textToSearch: this.$route.query.search || "",
    };
  },
  methods: {
    performModelSearch() {
    this.$router.push({
      name: "webstars.search",
      query: {
        search: this.textToSearch,
        t: Date.now(), // Añadimos un parámetro único con cada búsqueda
      },
    });
  },
  },
  watch: {
    $route: function() {
      this.textToSearch = this.$route.query.search || "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.model-search-container {
  width: 45%;
  border-radius: 50%;
  padding-block: 0.25em;

  @media (max-width: $MOBILE_DISPLAY) {
    width: 100%;
    padding: 1em 1.25em;
  }

  .search-form {
    height: 100%;
    display: flex;
    align-items: center;
    background: transparent;
    border-radius: 50px;
    border: 1px solid var(--pallete_main_color);



    input {
      position: relative;
      color: var(--pallete_clear_text_color);
      background-color: var(--pallete_dark_color);
      border: 1px solid var(--pallete_main_color);
      padding: 8px;
      font-size: 17px;
      height: 100%;

      @media (min-width: 769px) {
        width: 100%;
      }

      &:focus {
        box-shadow: none;
        outline: none;
      }
    }

    .search-icon-box {
      display: flex;
    }
    .search-icon {
      margin-block: 0.4em;
      margin-right: 0.4em;
      margin-left: 1.2em;
      width: unset;
      height: unset;
      background: unset;

      &::before {
        content: "\f002";
        font-size: 1.5em;

        color: var(--pallete_main_color);
      }
    }

    .search-icon-box:hover {
      cursor: pointer;
    }

    input {
      width: 100%;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;
      background-color: transparent;
      border: none;
    }
    
  }
}

</style>
